import { CMSDataValueModel } from "app/state/api/action-reducers/sync";
import { colors } from "app/theme";
import { getCMSDataField } from "app/utils/getCMSDataField";

export interface HeaderButtonProps {
  label: string;
  link?: string;
  color?: string;
  signIn?: boolean;
  expandable?: boolean;
  key: string;
}

export interface HeaderButtonsProps {
  activeButton: string;
  buttons: HeaderButtonProps[];
  handleButtonClick: (label: string) => void;
}

export const getHeaderButtonItems = (cmsData: CMSDataValueModel | null) => {
  const HEADER_BUTTON_ITEMS: HeaderButtonProps[] = [
    {
      label: getCMSDataField(
        cmsData,
        "general.aidaExplorerText",
        "AIDA Explorer"
      ),
      color: colors.shades.blue[400],
      expandable: true,
      key: "explorer",
    },
    {
      label: getCMSDataField(
        cmsData,
        "general.aidaPublisherText",
        "AIDA Publisher"
      ),
      color: colors.shades.green[400],
      expandable: true,
      key: "publisher",
    },
    {
      label: getCMSDataField(cmsData, "general.resourcesText", "Resources"),
      expandable: true,
      key: "resources",
    },
    {
      label: getCMSDataField(cmsData, "general.pricingLinkText", "Pricing"),
      link: "/pricing",
      key: "pricing",
    },
    {
      label: getCMSDataField(cmsData, "componentsHeader.signInText", "Sign In"),
      signIn: true,
      expandable: true,
      key: "signIn",
    },
  ];

  return HEADER_BUTTON_ITEMS;
};
